<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <a class="navbar-brand" routerLink="/account/tags">Tags</a>
  <button class="navbar-toggler" type="button" data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent" aria-expanded="false"
          aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <span class="mr-auto">
      <button
        mat-raised-button
        color="primary"
        (click)="onAdd()"
        id="add"
        class="m-1 mr-2"
        *ngIf="canCreate">
        <mat-icon>add</mat-icon>
        Add Tag
      </button>

      <!-- Import is a create operation. The hidden file input must stay outside the view-gated
           table container so users with only the create permission can still import tags. -->
      <ng-container *ngIf="canCreate">
        <button
          mat-raised-button
          class="m-1 mr-2"
          (click)="onTriggerFileSelector($event)"
          matTooltip="Click this button to import tags from spreadsheet.">
          <mat-icon>cloud_upload</mat-icon> Import
        </button>
        <input type="file" accept=".csv,text/csv" (change)="onImport($event)" style="display: none;" #fileInput />
      </ng-container>

      <!-- The mat-menu and its trigger buttons share a single guard. Angular Material renders mat-menu content in a CDK overlay, so an unguarded mat-menu leaks into the DOM even when the triggers are hidden. -->
      <!-- Mixed menu, so the trigger uses the union of its items and each item is gated on the
           permission its own API endpoint requires: export needs view (TagsController@exportByType),
           archive needs delete (@destroy) and restore needs edit (@restore). -->
      <ng-container *ngIf="canView || canDelete || canEdit">
        <mat-menu #appMenu="matMenu">
          <button *ngIf="canView || canDelete" mat-menu-item (click)="dataSource.selectAllToggle()">
            <mat-icon *ngIf="dataSource.isAllSelected()"> clear_all</mat-icon><mat-icon *ngIf="!dataSource.isAllSelected()">select_all</mat-icon>
            {{ dataSource.isAllSelected() ? 'Deselect' : 'Select' }} All
          </button>
          <button *ngIf="dataSource.archived == 'false' && canDelete" mat-menu-item (click)="onRemoveSelected()" [disabled]="!dataSource.selection.hasValue()">
            <mat-icon>archive</mat-icon> Archive Selected
          </button>
          <button *ngIf="dataSource.archived == 'false' && canView" mat-menu-item (click)="onExportSelected('csv')">
            <mat-icon>cloud_download</mat-icon> Export {{ dataSource.selection.hasValue() ? '(' + dataSource.selection.selected.length + ') Selected' : 'All' }} to CSV
          </button>
          <button *ngIf="dataSource.archived == 'true' && canEdit" mat-menu-item (click)="onRestoreSelected()" [disabled]="!dataSource.selection.hasValue()">
            <mat-icon>restore</mat-icon> Restore Selected
          </button>
        </mat-menu>

        <button *ngIf="dataSource.archived == 'false' && (canView || canDelete)" mat-button class="m-1 mr-2" [matMenuTriggerFor]="appMenu" matTooltip="Use this menu to select/deselect and/or export Tags." style="min-width: 150px">
          <mat-icon>more_vert</mat-icon>
          List Menu/Export
        </button>
        <button *ngIf="dataSource.archived == 'true' && (canView || canDelete || canEdit)" mat-button class="m-1 mr-2" [matMenuTriggerFor]="appMenu" matTooltip="Use this menu to select/deselect Tags." style="min-width: 120px">
          <mat-icon>more_vert</mat-icon>
          List Menu
        </button>
      </ng-container>
    </span>

    <button mat-raised-button class="m-1 mr-lg-3" (click)="onFilter()" matTooltip="Click this button to display filter options."
      *ngIf="canView">
      <mat-icon>filter_list</mat-icon> Filter
    </button>

    <form tourAnchor="tour.search" class="form-inline mx-1 my-0" (ngSubmit)="dataSource.getData(true)"
      *ngIf="canView">
      <input
        class="form-control ml-0 mr-2 my-1"
        type="search"
        [(ngModel)]="dataSource.search"
        name="search"
        placeholder="Search"
        aria-label="Search"
        matTooltip="Search for Tags" />

      <button
        mat-raised-button
        color="secondary"
        type="submit"
        class="mx-0 my-1"
        matTooltip="Run the current search">
        <mat-icon>search</mat-icon> Search
      </button>
    </form>
  </div>
</nav>

<div class="alert alert-warning m-2" *ngIf="!canView">
  <mat-icon class="align-middle mr-2">info</mat-icon>
  You do not have permission to view tags.
  <span *ngIf="canCreate">You can still create new tags using the button above.</span>
  <span *ngIf="!canCreate">Please contact your administrator to request access.</span>
</div>

<div class="mat-elevation-z8 scroll-box" *ngIf="canView">
  <table mat-table [dataSource]="dataSource" style="width: 100%" matSort matSortActive="title" matSortDisableClear>
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef [style.width.px]="65">
        <mat-checkbox
          (change)="$event ? dataSource.selectAllToggle() : null"
          [checked]="dataSource.selection.hasValue() && dataSource.isAllSelected()"
          [indeterminate]="dataSource.selection.hasValue() && !dataSource.isAllSelected()">
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox
          (click)="$event.stopPropagation()"
          (change)="$event ? dataSource.selection.toggle(row.id) : null"
          [checked]="dataSource.selection.isSelected(row.id)">
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="id">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>
        #
      </th>
      <td mat-cell *matCellDef="let tag">
        {{ tag.id }}
      </td>
    </ng-container>

    <ng-container matColumnDef="title">
      <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header>
        Tag
      </th>
      <td mat-cell *matCellDef="let tag" class="no-padding text-wrap">
        {{ tag.title }}
      </td>
    </ng-container>

    <ng-container matColumnDef="created_by_user">
      <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header>
        Created By
      </th>
      <td mat-cell *matCellDef="let tag" class="no-padding">
        <span *ngIf="tag?.created_by_user else showSystemCreator">
          <a (click)="onUserPublicView(tag.created_by_user.hash)" matTooltip="View User Public Profile">
            {{ tag.created_by_user.contact_person }}
          </a>
        </span>
        <ng-template #showSystemCreator>System</ng-template>
      </td>
    </ng-container>

    <ng-container matColumnDef="date_created">
      <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header>
        Created At
      </th>
      <td mat-cell *matCellDef="let tag" class="no-padding">
        {{ (tag.date_created * 1000) | timezoneConvertMedium }}
      </td>
    </ng-container>

    <ng-container matColumnDef="buttons">
      <th mat-header-cell *matHeaderCellDef [style.width.px]="240"></th>

      <td mat-cell *matCellDef="let tag">
        <button *ngIf="dataSource.archived == 'false' && canView" type="button" mat-button (click)="onView(tag.id)">
          View
        </button>

        <button *ngIf="dataSource.archived == 'false' && canEdit" type="button" mat-button (click)="onEdit(tag)">
          Edit
        </button>

        <button *ngIf="dataSource.archived == 'false' && canDelete" type="button" mat-button (click)="onRemove(tag)">
          Archive
        </button>

        <button *ngIf="dataSource.archived == 'true' && canEdit" type="button" mat-button (click)="onRestore(tag.id)">
          Restore
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>


  <mat-paginator
    [length]="dataSource?.total | async"
    [pageSize]="dataSource.limit"
    [pageSizeOptions]="dataSource.pageSizeOptions"
    showFirstLastButtons>
  </mat-paginator>
</div>
